import CardLimitsTab from './CardLimitsTab';

export default CardLimitsTab;
